export default __webpack_public_path__ + "static/media/seLogerBuCom.1c0c00ff.svg";